// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3VzTj","notes":"Notes_notes__1UMv-"};